// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_size = /** @type {(inputs: {}) => string} */ () => {
	return `Size`
};

const el_size = /** @type {(inputs: {}) => string} */ () => {
	return `Μέγεθος`
};

const ru_size = /** @type {(inputs: {}) => string} */ () => {
	return `Размер`
};

const he_size = /** @type {(inputs: {}) => string} */ () => {
	return `מידה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const size = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.size(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("size", locale)
	if (locale === "en") return en_size(inputs)
	if (locale === "el") return el_size(inputs)
	if (locale === "ru") return ru_size(inputs)
	if (locale === "he") return he_size(inputs)
	return "size"
};